import { ExporterDestinationAzure, ExporterDestinationBitbucket, ExporterDestinationDocs, ExporterDestinationGithub, ExporterDestinationGitlab, ExporterDestinationS3, GitObjectsQuery, PipelineDestinationType, PipelineEventType, } from "@supernova-studio/model";
import { DTOExporterPropertyValueMap } from "../../dto/export/exporter-property";
import { z } from "zod";
export const GitDestinationOptions = z.object({
    branch: z.string().min(1).nullish(),
    commitMessage: z.string().min(1).nullish(),
    commitAuthorName: z.string().min(1).nullish(),
    commitAuthorEmail: z.string().email().nullish(),
    commitToBranch: z.string().min(1).nullish(),
    pullRequestTitle: z.string().min(1).nullish(),
    pullRequestDescription: z.string().min(1).nullish(),
    relativePath: z.string().nullish(),
    purgeDirectory: z.boolean().nullish(),
});
export const DTOPipelineCreateBody = z.object({
    name: z.string(),
    exporterId: z.string(),
    designSystemId: z.string(),
    isEnabled: z.boolean(),
    eventType: PipelineEventType,
    brandPersistentId: z.string().optional(),
    themePersistentId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
    destination: PipelineDestinationType.optional(),
    gitQuery: GitObjectsQuery,
    destinations: z.object({
        s3: ExporterDestinationS3.nullish(),
        azure: ExporterDestinationAzure.nullish(),
        bitbucket: ExporterDestinationBitbucket.nullish(),
        github: ExporterDestinationGithub.nullish(),
        gitlab: ExporterDestinationGitlab.nullish(),
        documentation: ExporterDestinationDocs.nullish(),
        webhookUrl: z.string().nullish(),
    }),
});
export const DTODesignSystemPipelineCreateBody = z.object({
    name: z.string(),
    exporterId: z.string(),
    isEnabled: z.boolean(),
    eventType: PipelineEventType,
    brandPersistentId: z.string().optional(),
    themePersistentId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
    destination: PipelineDestinationType.optional(),
    gitQuery: GitObjectsQuery,
    destinations: z.object({
        s3: ExporterDestinationS3.nullish(),
        azure: ExporterDestinationAzure.nullish(),
        bitbucket: ExporterDestinationBitbucket.nullish(),
        github: ExporterDestinationGithub.nullish(),
        gitlab: ExporterDestinationGitlab.nullish(),
        documentation: ExporterDestinationDocs.nullish(),
        webhookUrl: z.string().nullish(),
    }),
});
export const DTOPipelineUpdateBody = z.object({
    exporterId: z.string().optional(),
    name: z.string().optional(),
    isEnabled: z.boolean().optional(),
    eventType: PipelineEventType.optional(),
    brandPersistentId: z.string().optional(),
    themePersistentId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
    destination: PipelineDestinationType.optional(),
    gitQuery: GitObjectsQuery.optional(),
    destinations: z
        .object({
        s3: ExporterDestinationS3.nullish(),
        azure: ExporterDestinationAzure.nullish(),
        bitbucket: ExporterDestinationBitbucket.nullish(),
        github: ExporterDestinationGithub.nullish(),
        gitlab: ExporterDestinationGitlab.nullish(),
        documentation: ExporterDestinationDocs.nullish(),
        webhookUrl: z.string().nullish(),
    })
        .optional(),
    gitDestinationOptions: GitDestinationOptions.partial().optional(),
});
export const DTOPipelineTriggerBody = z.object({
    designSystemVersionId: z.string(),
});
